import { createContext, useContext, useMemo } from 'react';

/**
 * FeaturesContext — holds the decoded subscription features object and subscription metadata.
 *
 * Shape:
 * {
 *   features: {
 *     dashboard: boolean,
 *     contacts: boolean,
 *     templates: boolean,
 *     campaign: boolean,
 *     inbox: boolean,
 *     users: boolean,
 *     crm: boolean,
 *     flows: boolean,
 *     integrations: boolean,
 *     leads: boolean,
 *     inquires: boolean,
 *     groups: boolean,
 *     configuration: boolean,
 *     reminders: boolean,
 *     appointments: boolean,
 *     quotations: boolean,
 *     available_integrations: string[],
 *   } | null,
 *   subscription: object | null,
 * }
 */
const FeaturesContext = createContext(null);

// eslint-disable-next-line react-refresh/only-export-components
export const useFeaturesContext = () => useContext(FeaturesContext);

export function FeaturesProvider({
  children,
  features = null,
  subscription = null,
}) {
  const value = useMemo(
    () => ({
      features,
      subscription,
    }),
    [features, subscription],
  );

  return (
    <FeaturesContext.Provider value={value}>
      {children}
    </FeaturesContext.Provider>
  );
}
